'use client';

import { useEffect } from 'react';

import { faExclamation } from '@fortawesome/pro-regular-svg-icons';

import { ProjectMessage } from '@/shared-project-response';
import { reportSurveyRenderError } from '@/survey-ssr-logger';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error }: Props) {
  useEffect(() => {
    reportSurveyRenderError(error, { boundary: 'global' });
  }, [error]);

  return (
    <html lang='en'>
      <body>
        <ProjectMessage
          icon={faExclamation}
          title='Oops, something went wrong'
          description='There was an error loading the survey. Please try again later.'
        />
      </body>
    </html>
  );
}
